import { defineStore } from 'pinia'
import { jwtDecode } from 'jwt-decode'

interface JwtToken {
    Domain: string,
    AccountId?: string,
    StaffId?: string,
    Username?: string,
    Role: string,
    FirstName?: string,
    LastName?: string,
    exp?: number,
    iat?: number,
}

interface State {
    token?: string | null
}

export const useAuthStore = defineStore('auth', {
    state: (): State => {
        const cookie = useCookie<string | undefined>('auth_token')
        return {
            token: cookie.value,
        }
    },

    getters: {
        tokenExpiryTime: (state) => {
            if (!state.token) return null
            const decoded = jwtDecode<JwtToken>(state.token)
            return decoded.exp ? decoded.exp * 1000 : null
        },
        jwtToken: (state): JwtToken | null => {
            const url = useRequestURL()
            const decoded = state.token ? jwtDecode<JwtToken>(state.token) : null

            if (decoded?.exp && decoded.exp * 1000 < Date.now()) return { Domain: url.hostname, Role: 'Anonymous' }

            return decoded
        },
    },

    actions: {
        setToken(token: string) {
            const cookie = useCookie<string | undefined>('auth_token')
            cookie.value = token
            this.token = token
        },
        clearToken() {
            const cookie = useCookie<string | undefined>('auth_token')
            cookie.value = undefined
            this.token = null
        },
    },
})
